
<div class="snack-bar-area">
  <mat-spinner *ngIf="snackBarStatus=='loading'" class="snack-spinner" diameter="25"></mat-spinner>
  <mat-icon *ngIf="snackBarStatus=='success'" class="success-icon">done</mat-icon>
  <mat-icon *ngIf="snackBarStatus=='error'" class="error-icon">priority_high</mat-icon>
  <p>{{snackBarText}}</p>
</div>
